module.exports = "<h2>No Checked Exceptions</h2><div class=\"fragment\"><h5>ZOMG!</h5><video autoplay=\"autoplay\" loop=\"loop\" data-ignore=\"data-ignore\"><source src=\"../../../resources/images/conan-clap.mp4\" type=\"video/mp4\"/></video></div>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/06-moar/05.pug
// module id = 335
// module chunks = 1